<template>
    <div>
        <BoxPaciente
            ref="BoxPaciente"
            :data="data"
        />

        <rkm-row
            class="mt-2 mb-2"
        >
            <rkm-col>
                <template>
                    <rkm-button
                        color="info"
                        class="mb-2"
                        @click="imprimirHistorico()"
                        :disabled="!data.model.agendamentos || data.model.agendamentos.length === 0"
                    >
                        Imprimir histórico
                    </rkm-button>
                </template>
            </rkm-col>
        </rkm-row>

        <rkm-table
            :fields="fields.tables.cancelados"
            :items="data.model.agendamentosCancelados"
            ref="Table"
            hide-filters
        >
            <template #cell(exames)="data">
                <span v-for="(exame, index) in data.item.exames" :key="index">
                    {{ exame.nomeExame }}<span v-if="index < data.item.exames.length - 1">, </span>
                </span>
            </template>

            <template #cell(usuarioCancelado)="data">
                {{ data.item.exames[0].usuarioCanceladoNome || '-' }}
            </template>

            <template #cell(dataCancelamento)="data">
                {{ data.item.exames[0].dataHoraCancelado || '-' }}
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :id="uniqueId('show-btn')"
                    @click="$refs.Modal.open(item)"
                    title="Detalhamento"
                    small
                    color="primary"
                >
                    <rkm-icon icon="search" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            ref="Modal"
            :data="data"
        />

    </div>
</template>
<script>

// Components.
import Modal from '@/components/exame-imagem/agendamento/tabs/cancelados/components/Modal'
import BoxPaciente from '@/components/exame-imagem/agendamento/paciente/Index'

// Filters.
import formats from '@/filters/formats'

// Vuex.
import { mapActions } from 'vuex'

//Enums
import status from '@/enums/exame-imagem/fechamento/status'

// Mixins.
import { repository, error, object, data, stringCase, printExameImagem } from '@/mixins'

export default {
    components:{ Modal, BoxPaciente },
    computed:{
        fields() {

            return {
                tables: {
                    cancelados: [
                        { key: 'data', label: 'Data', class: 'col-min'},
                        { key: 'horaExame', label: 'Horário', class: 'col-min text-center'},
                        { key: 'agendamentoNumero', label: 'Agendamento', class: 'col-min'},
                        { key: 'exames', label: 'Exames', class: 'col-max'},
                        { key: 'usuarioCancelado', label: 'Usuário que cancelou', class: 'col-max'},
                        { key: 'dataCancelamento', label: 'Data/Hora cancelado', class: 'col-max'},
                        { key: 'actions', label: 'Ações', class: 'col-min text-center'}
                    ]
                }
            }
        },
    },
    created() {

        this.repositories = {
            agendamento: this.getConectaSusRepository('exameImagem.agendamento'),
            impressao: this.getConectaSusRepository('impressao.exameImagem'),
        }
    },
    data:() => ({
        exames:[],
        agendamento: {
            data: null,
            grupoExameId: null,
            grupoExameNome: '',
            infraestruturaId: null,
            infraestruturaNome: '',
            agendamentoId: '',
            unidadeId: null,
            unidadeNome: '',
            unidadeDisabled: false,
            usuarioId: '',
            urgente: false,
            prestadorId: null,
            prestadorNome: '',
            medicoNome: '',
            medicoId: null,
        },
        isReadOnly: false,
        enums: {
            status
        },
    }),
    filters: {
        ...formats,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        imprimirHistorico(){

            this.setLoading()

            this.repositories.impressao.historicoExame(this.data.form.paciente.id)
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [ repository, error, object, data, stringCase, printExameImagem ],
    props: {
        data: { type: Object, required: true },
    },
}
</script>

<style scoped>
p {
    margin: 0px;
}
.col-svg {
    text-align: center !important;
}
.icon {
    width: auto !important;
    height: 96px !important;
    color: #007bff !important;
}
.warning {
    color: var(--warning);
}
.primary {
    color: var(--primary);
}
.colorButton {
    color: #fff;
}
</style>